import type React from 'react'
import { ApiError } from '../../lib/api-client'
import { da } from '../../lib/i18n'

export const s = da.listings

export interface Listing {
  id: string
  lease_id: string
  status: string
  title: string
  description: string | null
  husleje_oere: number
  published_at: string | null
  closed_at: string | null
  created_at: string
  updated_at: string
}

export interface Applicant {
  id: string
  listing_id: string
  name: string
  email: string
  phone: string | null
  status: string
  queue_position: number | null
  notes: string | null
}

export function fmtDate(d: string | null): string {
  if (!d) return '—'
  return new Date(d).toLocaleDateString('da-DK', { year: 'numeric', month: 'short', day: 'numeric' })
}

export const cardStyle: React.CSSProperties = {
  background: '#ffffff',
  borderRadius: 10,
  border: '1px solid #eef0f4',
}

export const thStyle: React.CSSProperties = {
  padding: '12px 16px',
  fontSize: 12,
  fontWeight: 600,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  textAlign: 'left',
  whiteSpace: 'nowrap',
}

export const tdStyle: React.CSSProperties = {
  padding: '14px 16px',
  color: '#374151',
  verticalAlign: 'middle',
  overflowWrap: 'anywhere',
}

export const fieldLabel: React.CSSProperties = {
  display: 'block',
  fontSize: 12,
  fontWeight: 500,
  color: '#64748b',
  marginBottom: 6,
}

export const fieldControl: React.CSSProperties = {
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  padding: '0 10px',
  height: 36,
  borderRadius: 7,
  border: '1px solid #e8ecf4',
  fontSize: 13,
  color: '#0f172a',
  background: '#ffffff',
  fontFamily: 'inherit',
}

/** Danish user-facing message for an API failure: backend text for 404/409/422, role text for 403. */
export function apiMsg(e: unknown, fallback: string): string {
  if (e instanceof ApiError) {
    if (e.status === 403) return s.forbidden
    if ((e.status === 404 || e.status === 409 || e.status === 422) && e.message && e.message !== 'Request failed') {
      return e.message
    }
  }
  return fallback
}
